import Cart from 'cart-store';
import {enabled,t,isAnimal,hasAnimals,hasPack,packId,readCart,notice} from 'lt3d-frost';
if (enabled) {
 let state = Cart.getState().cart;
 let updating = false;
 let cartError = '';
 let queued = false;
 const permitted = new WeakSet();
 const schedule = () => { if (!queued) { queued=true; requestAnimationFrame(()=>{queued=false;render();}); } };
 function render() {
  const animals = hasAnimals(state), missing = animals && !hasPack(state);
  document.querySelectorAll('product-form form').forEach(form=>{
   const affected = isAnimal({id:form.querySelector('[name="id"]')?.value});
   let box = form.querySelector('.lt3d-frost-product');
   if (affected && !box) {
    box=notice(Boolean(form.closest('product-card-mini'))); box.classList.add('lt3d-frost-product');
    const button=form.querySelector('[name="add"]');
    if(button) button.before(box);
   } else if (!affected && box) box.remove();
   const host=form.closest('product-form');
   host?.classList.toggle('lt3d-frost-animal',affected);
  });
  document.querySelectorAll('.cart__actions').forEach(actions=>{
   let box=actions.querySelector('.lt3d-frost-cart');
   if (!animals) {box?.remove();return;}
   if (!box) {
    box=notice();box.classList.add('lt3d-frost-cart');
    const status=document.createElement('p');status.className='lt3d-frost-status';status.setAttribute('aria-live','polite');
    const add=document.createElement('button');add.type='button';add.className='c-btn c-btn--primary c-btn--full';
    add.onclick=async()=>{
     if(updating)return;updating=true;cartError='';render();
     try{const fresh=await readCart();if(!hasPack(fresh))await Cart.add({id:packId,quantity:1});await Cart.refresh();}
     catch(e){cartError=e.message;}
     finally{updating=false;render();}
    };
    box.append(status,add);actions.prepend(box);
   }
   const status=box.querySelector('.lt3d-frost-status'), button=box.querySelector('button');
   const label=cartError || (missing?t(5):t(6));if(status.textContent!==label)status.textContent=label;
   if(button.textContent!==t(4))button.textContent=t(4);
   button.hidden=!missing;button.disabled=updating;
  });
  document.documentElement.classList.toggle('lt3d-frost-cart-animals',animals);
 }
 async function check() {
  const fresh=await readCart();state=fresh;render();
  if(hasAnimals(fresh)&&!hasPack(fresh)){
   document.querySelector('.lt3d-frost-cart button')?.focus();
   return false;
  }
  return true;
 }
 document.addEventListener('submit',async event=>{
  const form=event.target;
  if(permitted.has(form)){permitted.delete(form);return;}
  if(!event.submitter?.matches('[name="checkout"]'))return;
  event.preventDefault();event.stopImmediatePropagation();
  if(updating)return;updating=true;
  try{if(await check()){permitted.add(form);form.requestSubmit(event.submitter);}}
  catch(e){window.alert(t(8));}
  finally{updating=false;render();}
 },true);
 document.addEventListener('click',async event=>{
  const link=event.target.closest('a[href]');
  if(!link)return;
  const url=new URL(link.href,location.href);
  if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout(?:\/|$)/.test(url.pathname))return;
  event.preventDefault();event.stopImmediatePropagation();
  if(updating)return;updating=true;
  try{if(await check())location.assign(link.href);}catch(e){window.alert(t(8));}finally{updating=false;render();}
 },true);
 Cart.subscribe(next=>{state=next.cart;schedule();});
 new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
 document.addEventListener('change',schedule);
 window.addEventListener('pageshow',()=>Cart.refresh().catch(()=>{}));
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)Cart.refresh().catch(()=>{});});
 render();
}
